import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missions-entite-form',
  templateUrl: './missions-entite-form.component.html',
  styleUrls: ['./missions-entite-form.component.scss']
})
export class MissionsEntiteFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
